import { useViewportSize } from '@mantine/hooks';
import classes from './index.module.scss';

interface ChartItem {
  label: string;
  value: number;
  color: string;
}

interface DonutChartProps {
  data: ChartItem[];
  thickness: number;
  size?: number;
}

const getChartSize = (width: number) => {
  if (width < 768) return 240; // mobile
  if (width < 1200) return 200; // tablet
  return 200; // desktop
};

const DonutChart = ({ data, thickness }: DonutChartProps) => {
  const { width } = useViewportSize();
  let rotation = 0;
  const size = getChartSize(width);
  const radius = size / 2;

  const isEmpty = data.filter((item) => item.value > 0).length === 0;

  return (
    <ul
      className={classes.chart}
      style={{
        width: size,
        height: radius,
      }}
    >
      {isEmpty ? (
        <li
          style={{
            transform: 'rotate(180deg)',
            borderInline: `${thickness}px solid var(--mantine-color-gray-2)`,
            borderBottom: `${thickness}px solid var(--mantine-color-gray-2)`,
            borderBottomLeftRadius: `${radius}px`,
            borderBottomRightRadius: `${radius}px`,
          }}
        />
      ) : (
        <>
          {data.map((item, index) => {
            rotation += item.value * 1.8;

            return (
              <li
                key={index}
                style={{
                  zIndex: data.length - index,
                  transform: `rotate(${rotation}deg)`,
                  borderInline: `${thickness}px solid ${item.color}`,
                  borderBottom: `${thickness}px solid ${item.color}`,
                  borderBottomLeftRadius: `${radius}px`,
                  borderBottomRightRadius: `${radius}px`,
                }}
              />
            );
          })}
        </>
      )}
    </ul>
  );
};

export default DonutChart;
